import SideNavigation from "../Common/sideNavigation";
import UserRequestsTable from "../UserManagement/UserRequests/userRequestsTable";
import DOIRequestTable from '../DOIRequests/DOITable/doiTable';
import ProjectApprovalTable from "../ProjectApproval/projectApprovalTable";

/**
 * Returns the Admin Dashboard Content page component.
 * 
 * @returns The Admin Dashboard Content page component.
 */
export default function DashboardContent() {

  return (
    <>
      <div className="flex flex-col h-fit md:h-screen  bg-gray-50">
        <div className="h-fit bg-gray-50">
          <SideNavigation />

          <main className="lg:pl-72 bg-gray-50 h-full">
            <div className="">
              <div className="px-4 pt-6 sm:px-6 lg:px-8 lg:pt-6">
                <h1 className="text-3xl mb-4 font-bold leading-tight text-gray-900">
                  Dashboard
                </h1>

                <div className="grid grid-cols-2 space-x-0 2xl:space-x-6 space-y-4 2xl:space-y-0">
                  <div className="col-span-3 2xl:col-span-1 h-full">
                    <DOIRequestTable />
                  </div>
                  <div className="col-span-3 2xl:col-span-1 py-6 px-6 md:py-12 bg-white border border-gray-200 rounded-lg shadow-sm">
                    <header className="md:w-full">
                      <h2 className="text-2xl py-2 font-bold leading-tight text-gray-900">
                        Contributor Access Requests
                      </h2>
                    </header>

                    <main className="mt-2 overflow-hidden">
                      <div className="">
                        <UserRequestsTable />
                      </div>
                    </main>
                  </div>
                </div>

              </div>
              <ProjectApprovalTable />
            </div>
          </main>
        </div>
      </div>
    </>
  )
}